import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-top-up',
  templateUrl: './top-up.component.html',
  styleUrls: ['./top-up.component.css'],
})

export class TopUpComponent {
  @Input() topUp: string | null;
}
